import { render, staticRenderFns } from "./FieldUnScore.vue?vue&type=template&id=f83352ac&"
import script from "./FieldUnScore.vue?vue&type=script&lang=js&"
export * from "./FieldUnScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FieldUnScore.vue"
export default component.exports